import React from 'react';
import './ChairmansMessage.css';
import { FaQuoteLeft, FaQuoteRight } from 'react-icons/fa';


const ChairmansMessage = () => {
  return (
    <section className="chairman-message">
      <div className="chairman-message-wrapper">
        <h2 className="chairman-message-section-title">A Message from the Chairman</h2>
        <div className="message-container">
          <div className="chairman-message-quote-icon">
            <FaQuoteLeft />
          </div>
          <div className="message-content">
            {/* <p>{chairmansMessage.quoteStart}{chairmansMessage.message}{chairmansMessage.quoteEnd}</p> */}
            <p>Dear Citizens of Igbo-Eze North,</p>
            <br />
            <p>It is with deep gratitude and purpose that I welcome you to the official website of the Igbo-Eze North Local Government Council.</p>
            <br />
            <p>As we navigate the 2025–2029 development period, our administration is focused on one mission: inclusive and measurable progress at the grassroots. We are committed to upgrading infrastructure, improving healthcare, expanding educational opportunities, and unlocking economic growth — with accountability and transparency at the core of everything we do.</p>
            <br />
            <p>This is more than just a digital platform — it is a bridge between the government and the people. I encourage you to use it to access services, track projects, give feedback, and stay connected to the work we are doing in every ward, community, and development centre.</p>
            <br />
            <p>Together, we are building a local government that works — for everyone.</p>
            <br />
            <p>Thank you for your trust and support.</p>
            <br />
            {/* <p>- <strong>{chairmansMessage.name}</strong></p> */}
            <p><strong>Hon. Engr. Michael Uche Ogalla.</strong></p>
            <p>Executive Chairman</p>
            <p>Igbo-Eze North LGA</p>
          </div>
          <div className="chairman-message-quote-icon">
            <FaQuoteRight />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChairmansMessage;